const $filters = document.querySelector('.aside-filters');
const $filtersOpen = document.querySelector('.open-filters');
const $filtersClose = document.querySelector('.close-filters');

if($filters) {
    $filtersOpen.addEventListener('click', ()=> {
        $filters.classList.add('aside-filters--active')
    })
    $filtersClose.addEventListener('click', (e)=> {
        e.preventDefault();
        $filters.classList.remove('aside-filters--active')
    })
}